<p-toast></p-toast>
<p-dialog
  [(visible)]="display"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [breakpoints]="{ '960px': '92vw', '640px': '95vw' }"
  [style]="{ width: '80vw', maxWidth: '72rem' }"
  styleClass="dup-dialog"
  (onHide)="hide()"
>
  <ng-template pTemplate="header">
    <span class="dup-dialog-title">Duplicate Record</span>
  </ng-template>

  <div
    *ngIf="!isDuplicating && duplicatedRecords.length === 0"
    class="dup-dialog-toolbar"
  >
    <p-button
      [label]="allSelected ? 'Deselect All' : 'Select All'"
      [icon]="allSelected ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-check'"
      iconPos="right"
      styleClass="p-button-sm p-button-secondary"
      (onClick)="toggleAllSelection()"
    ></p-button>

    <p-button
      *ngIf="isBulk"
      [label]="allPanelsExpanded ? 'Collapse All' : 'Expand All'"
      [icon]="allPanelsExpanded ? 'fa-solid fa-compress' : 'fa-solid fa-expand'"
      iconPos="right"
      styleClass="p-button-sm p-button-secondary"
      (onClick)="toggleAllPanels()"
    ></p-button>
  </div>

  <!-- Preview - Edit values -->
  <div *ngIf="!isDuplicating && duplicatedRecords.length === 0" class="dup-preview-container">
    <!-- Bulk preview -->
    <div *ngIf="isBulk">
      <p-accordion>
        <p-accordionTab
          *ngFor="let recordId of payload._id"
          [header]="'Source ID: ' + records[recordId]?.id + (records[recordId]?.name ? ' - ' + records[recordId]?.name : '')"
          [(selected)]="expandedPanels[recordId]"
        >
          <div class="dup-fields-table">
            <div class="dup-fields-header">
              <div class="dup-field-cell dup-field-cell--label"><strong>Field</strong></div>
              <div class="dup-field-cell dup-field-cell--duplicate"><strong>Duplicate?</strong></div>
              <div class="dup-field-cell dup-field-cell--value"><strong>Value</strong></div>
            </div>

            <div class="dup-field-row" *ngFor="let rowData of records[recordId]?.tableData || []">
              <div class="dup-field-cell dup-field-cell--label">
                <span class="dup-field-mobile-label">Field</span>
                <span class="dup-field-label-text">
                  {{ rowData.label }}
                  <span *ngIf="rowData.required" class="dup-required">*</span>
                </span>
              </div>
              <div class="dup-field-cell dup-field-cell--duplicate">
                <span class="dup-field-mobile-label">Duplicate?</span>
                <div class="dup-field-checkbox">
                  <p-checkbox
                    [(ngModel)]="rowData.duplicate"
                    [binary]="true"
                    (onChange)="onItemSelected(rowData)"
                    [disabled]="rowData.required"
                  ></p-checkbox>
                  <span
                    *ngIf="rowData.duplicateMessage"
                    class="dup-info-icon"
                    pTooltip="{{ rowData.duplicateMessage }}"
                  >
                    <i class="fa-solid fa-circle-info"></i>
                  </span>
                </div>
              </div>
              <div class="dup-field-cell dup-field-cell--value">
                <span class="dup-field-mobile-label">Value</span>
                <app-dup-dialog-row
                  [rowData]="rowData"
                  [controller]="rowData.controller"
                  [apiOptions]="apiOptions"
                  (valueChange)="onRowValueChange(rowData, $event)"
                  [disabled]="!rowData.duplicate"
                ></app-dup-dialog-row>
              </div>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>

    <!-- Single record preview -->
    <div *ngIf="!isBulk" class="dup-fields-table">
      <div class="dup-fields-header">
        <div class="dup-field-cell dup-field-cell--label"><strong>Field</strong></div>
        <div class="dup-field-cell dup-field-cell--duplicate"><strong>Duplicate?</strong></div>
        <div class="dup-field-cell dup-field-cell--value"><strong>Value</strong></div>
      </div>

      <div class="dup-field-row" *ngFor="let rowData of tableData">
        <div class="dup-field-cell dup-field-cell--label">
          <span class="dup-field-mobile-label">Field</span>
          <span class="dup-field-label-text">
            {{ rowData.label }}
            <span *ngIf="rowData.required" class="dup-required">*</span>
          </span>
        </div>
        <div class="dup-field-cell dup-field-cell--duplicate">
          <span class="dup-field-mobile-label">Duplicate?</span>
          <div class="dup-field-checkbox">
            <p-checkbox
              [(ngModel)]="rowData.duplicate"
              [binary]="true"
              (onChange)="onItemSelected(rowData)"
              [disabled]="rowData.required"
            ></p-checkbox>
            <span
              *ngIf="rowData.duplicateMessage"
              class="dup-info-icon"
              pTooltip="{{ rowData.duplicateMessage }}"
            >
              <i class="fa-solid fa-circle-info"></i>
            </span>
          </div>
        </div>
        <div class="dup-field-cell dup-field-cell--value">
          <span class="dup-field-mobile-label">Value</span>
          <app-dup-dialog-row
            [rowData]="rowData"
            [controller]="rowData.controller"
            [apiOptions]="apiOptions"
            (valueChange)="onRowValueChange(rowData, $event)"
            [disabled]="!rowData.duplicate"
          ></app-dup-dialog-row>
        </div>
      </div>
    </div>
  </div>

  <!-- Show progress bar when duplicating -->
  <div *ngIf="isDuplicating" class="dup-progress p-text-center p-mb-3">
    <ngx-spinner
      name="dup-dialog-spinner"
      bdColor="rgba(36,34,36,0.8)"
      size="small"
      color="#81c784"
      type="line-scale"
    >
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
    <div class="p-pt-5">
      <hr>
      <p class="p-my-4">Duplicating records... {{ duplicationProgress }}%</p>
      <hr>
    </div>
  </div>

  <!-- Results view -->
  <div *ngIf="duplicatedRecords.length > 0" class="dup-results-container p-mt-3">
    <div class="dup-results-header">
      <div class="dup-result-cell dup-result-cell--source">Source ID</div>
      <div class="dup-result-cell dup-result-cell--new">New Record</div>
      <div class="dup-result-cell dup-result-cell--status">Status</div>
    </div>

    <div class="dup-result-row" *ngFor="let record of duplicatedRecords">
      <div class="dup-result-cell dup-result-cell--source">
        <span class="dup-field-mobile-label">Source ID</span>
        <a
          [href]="'/' + route + '/' + record.sourceId"
          target="_blank"
          [ngStyle]="{ color: 'var(--primary-color)' }"
        >
          {{ record.sourceId }}
        </a>
      </div>
      <div class="dup-result-cell dup-result-cell--new">
        <span class="dup-field-mobile-label">New Record</span>
        <a
          *ngIf="record.success"
          [href]="'/' + route + '/' + record.newId"
          target="_blank"
          [ngStyle]="{ color: 'var(--primary-color)' }"
        >
          {{ record.newId }}
        </a>
      </div>
      <div class="dup-result-cell dup-result-cell--status">
        <span class="dup-field-mobile-label">Status</span>
        <span [class]="record.success ? 'success-status' : 'error-status'">
          {{ record.success ? 'Success' : 'Failed' }}
        </span>
        <span *ngIf="!record.success" class="error-message">: {{ record.error }}</span>
      </div>

      <!-- Sub-creations section -->
      <div class="dup-result-sub" *ngIf="record.subCreations">
        <p-divider></p-divider>
        <div class="dup-result-sub-content">
          <!-- Inbox Messages -->
          <div *ngIf="record.subCreations.inboxMessages?.length > 0" class="p-mb-3">
            <h4>Duplicated Inbox Messages:</h4>
            <div *ngFor="let inbox of record.subCreations.inboxMessages" class="p-ml-2">
              <span>
                {{ inbox.name }}
                <a
                  [href]="'/inbox-messages/' + inbox.id"
                  target="_blank"
                  [ngStyle]="{ color: 'var(--primary-color)' }"
                >
                  ({{ inbox.id }})
                </a>
              </span>
            </div>
          </div>

          <!-- Announcement Inbox -->
          <div *ngIf="record.subCreations.announcementInbox" class="p-mb-3">
            <h4>Duplicated Announcement Inbox:</h4>
            <div class="p-ml-2">
              <span>
                {{ record.subCreations.announcementInbox.name }}
                <a
                  [href]="'/inbox-messages/' + record.subCreations.announcementInbox.id"
                  target="_blank"
                  [ngStyle]="{ color: 'var(--primary-color)' }"
                >
                  ({{ record.subCreations.announcementInbox.id }})
                </a>
              </span>
            </div>
          </div>

          <!-- Challenges -->
          <div *ngIf="record.subCreations.challenges?.length > 0" class="p-mb-3">
            <h4>Duplicated Challenges:</h4>
            <div *ngFor="let challenge of record.subCreations.challenges" class="p-ml-2">
              <strong>Challenge:</strong>
              <span>
                {{ challenge.name }}
                <a
                  [href]="'/challenges/' + challenge.id"
                  target="_blank"
                  [ngStyle]="{ color: 'var(--primary-color)' }"
                >
                  ({{ challenge.id }})
                </a>
              </span>
              <div *ngIf="challenge.modifiedPrizes?.length > 0" class="p-ml-4 p-mt-2">
                <p class="text-sm font-italic">Modified Item Prizes:</p>
                <div *ngFor="let prize of challenge.modifiedPrizes" class="p-ml-2 text-sm">
                  <strong>Item:</strong>
                  <span>
                    {{ prize.name }}
                    <a
                      [href]="'/items/' + prize.id"
                      target="_blank"
                      [ngStyle]="{ color: 'var(--primary-color)' }"
                    >
                      ({{ prize.id }})
                    </a>
                    <strong class="p-ml-2">Re-Release Start:</strong>
                    {{ prize.reReleaseStart | officeTime }}
                  </span>
                </div>
              </div>
              <hr>
            </div>
          </div>

          <!-- Loading Screens -->
          <div *ngIf="record.subCreations.loadingScreens?.length > 0" class="p-mb-3">
            <h4>Edited Loading Screens:</h4>
            <div *ngFor="let loadingScreen of record.subCreations.loadingScreens" class="p-ml-2">
              <strong>Loading Screen:</strong>
              <span>
                {{ loadingScreen.name }}
                <a
                  [href]="'/loading-screens/' + loadingScreen.id"
                  target="_blank"
                  [ngStyle]="{ color: 'var(--primary-color)' }"
                >
                  ({{ loadingScreen.id }})
                </a>
                <strong class="p-ml-2">Start:</strong>
                {{ loadingScreen.start | officeTime }}
                <strong class="p-ml-2">End:</strong>
                {{ loadingScreen.end | officeTime }}
                <strong class="p-ml-2">Env:</strong>
                [dev, qa]
              </span>
            </div>
          </div>

          <!-- Collections -->
          <div *ngIf="record.subCreations?.collections?.length > 0" class="p-mb-3">
            <h4>Duplicated Collections:</h4>
            <div *ngFor="let collection of record.subCreations.collections" class="p-ml-2">
              <strong>Collection:</strong>
              <span>
                {{ collection.name }}
                <a
                  [href]="'/collections/' + collection.id"
                  target="_blank"
                  [ngStyle]="{ color: 'var(--primary-color)' }"
                >
                  ({{ collection.id }})
                </a>
                <span *ngIf="collection.start" class="p-ml-2">
                  <strong>Start:</strong>
                  {{ collection.start | officeTime }}
                </span>
                <span *ngIf="collection.end" class="p-ml-2">
                  <strong>End:</strong>
                  {{ collection.end | officeTime }}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dup-dialog-footer">
      <button
        pButton
        label="Cancel"
        (click)="onCancel()"
        class="p-button-danger"
        *ngIf="!isDuplicating && duplicatedRecords.length === 0"
      ></button>

      <button
        pButton
        label="Duplicate"
        (click)="onDuplicate()"
        [disabled]="isDuplicating"
        class="p-button-success"
        *ngIf="duplicatedRecords.length === 0"
      ></button>

      <button
        pButton
        label="Close"
        (click)="hide()"
        class="p-button-primary"
        *ngIf="duplicatedRecords.length > 0"
      ></button>
    </div>
  </ng-template>
</p-dialog>
